import React from "react";
import { ShowSidePanel } from "../Show/ShowSidePanel";
import { FlightSidePanel } from "../Flight/FlightSidePanel";
import { TrainSidePanel } from "../Train/TrainSidePanel";
import { GroundTransportSidePanel } from "../GroundTransport/GroundSidePanel";
import { ExternalEventSidePanel } from "../ExternalEvent/ExternalEventSidePanel";

interface AppointmentSidePanelProps {
  appointment: server.dto.AppointmentForPlanner;
  children: JSX.Element;
}

export const AppointmentSidePanel = (props: AppointmentSidePanelProps) => {
  const { appointment, children } = props;

  switch (appointment.type.value) {
    case "externalCalendar":
      return <ExternalEventSidePanel externalEventId={appointment.id} trigger={children} />;
    case "show":
      return <ShowSidePanel canEdit showId={appointment.id} trigger={children} />;
    case "flight":
      return <FlightSidePanel flightId={appointment.id} trigger={children} />;
    case "train":
      return <TrainSidePanel trainSegmentId={appointment.id} trigger={children} />;
    case "groundTransport":
      return <GroundTransportSidePanel groundTransportId={appointment.id} trigger={children} />;
    default:
      return children;
  }
};

interface AppointmentSidePanelPlannerProps {
  appointment: server.dto.PlannerAppointment;
  children: JSX.Element;
}

export const AppointmentSidePanelPlanner = (props: AppointmentSidePanelPlannerProps) => {
  const { appointment, children } = props;

  switch (appointment.type.value) {
    case "externalCalendar":
      return <ExternalEventSidePanel externalEventId={appointment.externalEventId} trigger={children} />;
    case "show":
      return <ShowSidePanel canEdit showId={appointment.showId} trigger={children} />;
    case "flight":
      return <FlightSidePanel flightId={appointment.flightId} trigger={children} />;
    case "train":
      return <TrainSidePanel trainSegmentId={appointment.trainSegmentId} trigger={children} />;
    case "groundTransport":
      return <GroundTransportSidePanel groundTransportId={appointment.groundTransportId} trigger={children} />;
    default:
      return children;
  }
};
